if (typeof window.ShopifyCheckout !== "function") {
  window.ShopifyCheckout = class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.addEventListener("click", (evt) => {
        this.handleSubmit(evt);
      });
    }
    handleSubmit(evt) {
      this.classList.add("loading");
      if (this.dataset.customBundle)
        return this.handleCustomBundleCheckout(evt);
      return this.handleCheckout();
    }
    async clearCartAndHandleItems(customBundle = false) {
      const cartData = await apiFetchJson("", "/cart.js");
      const items = cartData.items.filter((item) =>
        customBundle
          ? item.properties["_my-bundle"]
          : !item.properties["_my-bundle"]
      );
      const body = JSON.stringify({
        items,
      });
      if (items.length !== cartData.items.length) {
        await fetch(`${routes.cart_clear_url}`, { ...fetchConfig() });
        await fetch(`${routes.cart_add_url}`, {
          ...fetchConfig(),
          ...{ body },
        });
      }
    }
    proceedToCheckout() {
      return window.location.assign(routes.checkout);
    }

    async handleCustomBundleCheckout(evt) {
      const submitButton = evt.target;
      const discountCode = submitButton.dataset.slug;
      await this.clearCartAndHandleItems(true);
      if (discountCode) {
        await apiFetchText("", `${routes.discount}/${discountCode}`);
      }
      this.proceedToCheckout();
    }
    async handleCheckout() {
      await this.clearCartAndHandleItems();
      this.proceedToCheckout();
    }
  };
}
if (!customElements.get("shopify-checkout-button")){
  customElements.define("shopify-checkout-button", ShopifyCheckout);
}